import React from 'react';
import { useEffect, useState } from 'react';
import  Chatbot  from '../../components/ui/chatbot';

const About = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-r from-blue-500 to-purple-600 text-white">
        <div className="container mx-auto px-6 text-center">
          <h1 className={`text-4xl md:text-6xl font-bold mb-6 ${loaded ? 'animate-fade-in' : 'opacity-0'}`}>
            About Our Company
          </h1>
          <p className={`text-xl md:text-2xl max-w-3xl mx-auto ${loaded ? 'animate-fade-in' : 'opacity-0'}`} style={{ animationDelay: '100ms' }}>
            We're revolutionizing the industry with innovative solutions and a passionate team.
          </p>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-16 bg-white transform skew-y-1 origin-top-left"></div>
      </section>

      {/* Mission Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 mb-10 md:mb-0 md:pr-10">
              <h2 className="text-3xl font-bold text-blue-500 mb-6">Our Mission</h2>
              <p className="text-lg text-gray-700 mb-6">
                To empower businesses and individuals through cutting-edge technology and exceptional user experiences.
              </p>
              <p className="text-lg text-gray-700 mb-6">
                We believe in creating solutions that are not only functional but also delightful to use.
              </p>
              <button className="bg-blue-500 hover:bg-purple-600 text-white font-bold py-3 px-6 rounded-full transition duration-300">
                Learn More
              </button>
            </div>
            <div className="md:w-1/2">
              <div className="bg-gray-100 rounded-xl p-2 shadow-inner">
                <img 
                  src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" 
                  alt="Team working" 
                  className="rounded-lg w-full h-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div className="p-8 rounded-xl bg-white shadow-md">
              <div className="text-5xl font-bold text-blue-500 mb-2">50+</div>
              <div className="text-gray-600">Happy Clients</div>
            </div>
            <div className="p-8 rounded-xl bg-white shadow-md">
              <div className="text-5xl font-bold text-blue-500 mb-2">10+</div>
              <div className="text-gray-600">Years Experience</div>
            </div>
            <div className="p-8 rounded-xl bg-white shadow-md">
              <div className="text-5xl font-bold text-blue-500 mb-2">24/7</div>
              <div className="text-gray-600">Customer Support</div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-blue-500 mb-4">Meet Our Team</h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              The talented people behind our success
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Team Member 1 */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-1 animate-fade-in" style={{ animationDelay: '100ms' }}>
              <div className="h-48 overflow-hidden">
                <img 
                  src="https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60" 
                  alt="Alex Johnson" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-blue-500">Alex Johnson</h3>
                <p className="text-purple-600 font-medium mb-2">CEO & Founder</p>
                <p className="text-gray-600">Visionary leader with 10+ years of experience in tech innovation and business strategy.</p>
              </div>
            </div>

            {/* Team Member 2 */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-1 animate-fade-in" style={{ animationDelay: '200ms' }}>
              <div className="h-48 overflow-hidden">
                <img 
                  src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60" 
                  alt="Maria Garcia" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-blue-500">Maria Garcia</h3>
                <p className="text-purple-600 font-medium mb-2">CTO</p>
                <p className="text-gray-600">Tech enthusiast passionate about building scalable solutions and mentoring engineering teams.</p>
              </div>
            </div>

            {/* Team Member 3 */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-1 animate-fade-in" style={{ animationDelay: '300ms' }}>
              <div className="h-48 overflow-hidden">
                <img 
                  src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60" 
                  alt="James Wilson" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-blue-500">James Wilson</h3>
                <p className="text-purple-600 font-medium mb-2">Lead Designer</p>
                <p className="text-gray-600">Creative mind focused on user-centered design and beautiful interfaces.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-blue-500 to-purple-600 text-white">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold mb-6">Ready to work with us?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Let's create something amazing together. Get in touch today!
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <button className="bg-white text-blue-500 hover:bg-gray-100 font-bold py-3 px-8 rounded-full transition duration-300">
              Contact Us
            </button>
            <button className="border-2 border-white text-white hover:bg-white hover:text-blue-500 font-bold py-3 px-8 rounded-full transition duration-300">
              Learn More
            </button>
          </div>
        </div>
      </section>
      <Chatbot />
    </div>
  );
};

export default About;